"use client";

import type { FC } from "react";

import { isPreviewing } from "@builder.io/sdk-react";
import classNames from "classnames";

import { useLoyaltyHeroDataTransform } from "@jti/loyalty/hooks/useLoyaltyHeroDataTransform/useLoyaltyHeroDataTransform";
import { HeroBackground } from "@jti/ui/components/HeroV2/HeroBackground/HeroBackground";
import { HeroContent } from "@jti/ui/components/HeroV2/HeroContent";
import { buildHeroContent } from "@jti/ui/components/HeroV2/utils/buildHeroContent";

import type { heroLoyaltyInputs } from "./LoyaltyHero.builder";

export type LoyaltyHeroProps = BuilderComponentProps<typeof heroLoyaltyInputs>;

// This component is a copy of HeroBannerContainer component made due to tight coupling of component. Tech debpt ticket was created to revisit hero banner like components DESP-96085
export const LoyaltyHero: FC<LoyaltyHeroProps> = ({ data }) => {
  const { convertToHeroData } = useLoyaltyHeroDataTransform();

  const properProps = convertToHeroData(data);

  return (
    <div>
      <HeroBackground
        backgroundType={properProps.backgroundType}
        desktopImage={properProps.desktopImage}
        mediumImage={properProps.mediumImage}
        smallImage={properProps.smallImage}
        tabletVideoFileReference={properProps.tabletVideoFileReference}
        mobileVideoFileReference={properProps.mobileVideoFileReference}
        videoFileReference={properProps.videoFileReference}
        removeVideoRoundedCorners={true}
        imageClassName={classNames({
          "previewing-content": isPreviewing(),
        })}
        videoClassName={classNames({
          "previewing-content": isPreviewing(),
        })}
      />
      <div>
        <HeroContent
          {...buildHeroContent(properProps, false)}
          heroContentClassName={classNames({
            "previewing-content": isPreviewing(),
          })}
        />
      </div>
    </div>
  );
};
